import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
import { AppRouteRecordRaw } from '@/common/types/appRoute.type'

export const constantRoutes: Array<AppRouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/user/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'register',
    hidden: true,
    component: () => import('@/views/user/register/index.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/matchFullScreen',
    name: 'matchFullScreen',
    hidden: true,
    component: () => import('@/views/match/fullScreen/index.vue'),
    meta: { title: '比赛大屏' }
  },
  {
    path: '/matchJudgeScreen',
    name: 'matchJudgeScreen',
    hidden: true,
    component: () => import('@/views/match/judgeScreen/index.vue'),
    meta: { title: '比赛裁判' }
  },
  {
    path: '/match/view',
    component: () => import('@/views/btkapp/match/match_view.vue'),
    name: 'match_view',
    meta: { title: '比赛详情' }
  },
]

export const asyncRoutes: Array<AppRouteRecordRaw> = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '首页', icon: 'permission' },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'home' }
      },
      { path: 'config', component: () => import('@/views/dashboard/index_config.vue'), name: 'dashboard_config', meta: { title: '广告配置', icon: 'home' } }
    ]
  },
  {
    path: '/test',
    component: Layout,
    redirect: '/test/index',
    children: [
      { path: 'index', component: () => import('@/views/btkapp/config/index.vue'), name: 'test_index', meta: { title: '测试', icon: 'home' } }
    ]
  },
  {
    path: '/team',
    component: Layout,
    redirect: '/team/info',
    meta: { title: '单位空间', icon: 'permission' },
    name: 'team',
    children: [
      { path: 'info', component: () => import('@/views/btkTeam/info/index.vue'), name: 'team_info', meta: { title: '单位信息' }, hidden: false },
      { path: 'signmatch', component: () => import('@/views/btkTeam/sign/indexMatch.vue'), name: 'team_sign', meta: { title: '单位报名' } },
      { path: 'signmatchitem', component: () => import('@/views/btkTeam/sign/matchPortal.vue'), name: 'team_sign_item', meta: { title: '项目报名' }, hidden: true },
      { path: 'play', component: () => import('@/views/btkTeam/playerManager/index.vue'), name: 'team_player', meta: { title: '运动员管理' } },
      { path: 'offical', component: () => import('@/views/btkTeam/officalManager/index.vue'), name: 'team_offical', meta: { title: '官员信息' } },
      { path: 'history', component: () => import('@/views/btkTeam/history/index.vue'), name: 'team_history', meta: { title: '单位比赛历史' }, hidden: true },
      { path: 'contact', component: () => import('@/views/btkTeam/contact/index.vue'), name: 'contact', meta: { title: '技术咨询' }, hidden: false },
    ]
  },
  {
    path: '/person',
    component: Layout,
    name: 'person',
    meta: { title: '个人空间', icon: 'permission' },
    redirect: '/person/info',
    children: [
      { path: 'info', component: () => import('@/views/btkPerson/info/index.vue'), name: 'person_info', meta: { title: '个人信息' }, hidden: true },
      { path: 'sign', component: () => import('@/views/btkPerson/sign/indexMatch.vue'), name: 'person_sign', meta: { title: '比赛报名' } },
      { path: 'signitem', component: () => import('@/views/btkPerson/sign/indexItems.vue'), name: 'person_sign_item', meta: { title: '项目报名' }, hidden: true },
      { path: 'history', component: () => import('@/views/btkPerson/history/index.vue'), name: 'person_history', meta: { title: '个人比赛历史' }, hidden: true },
    ]
  },
  {
    path: '/match',
    component: Layout,
    name: 'match',
    meta: { title: '比赛管理', icon: 'permission' },
    redirect: '/match/index',
    children: [
      { path: 'index', component: () => import('@/views/btkapp/match/index.vue'), name: 'match_index', meta: { title: '比赛列表' } },
      { path: 'config', component: () => import('@/views/btkapp/match/config.vue'), name: 'match_config', meta: { title: '比赛配置' }, hidden: true },
      { path: 'item', component: () => import('@/views/btkapp/match/config_items_play.vue'), name: 'match_item', meta: { title: '运动员管理' }, hidden: true },
      { path: 'itemgroup', component: () => import('@/views/btkapp/match/config_items_groupplay.vue'), name: 'match_item_group', meta: { title: '团体项目运动员管理' }, hidden: true }
    ]
  },
  {
    path: '/draw',
    component: Layout,
    name: 'draw',
    meta: { title: '抽签管理', icon: 'permission' },
    redirect: '/draw/index',
    children: [
      { path: 'index', component: () => import('@/views/btkapp/draw/index.vue'), name: 'draw_index', meta: { title: '抽签' } },
    ]
  },
  {
    path: '/perm',
    component: Layout,
    name: 'perm',
    meta: { title: '权限管理', icon: 'permission' },
    redirect: '/perm/users',
    children: [
      { path: 'teamusers', component: () => import('@/views/permission/users/index.vue'), name: 'team_users', meta: { title: '单位用户管理' } },
      { path: 'plays', component: () => import('@/views/permission/users/play.vue'), name: 'team_plays', meta: { title: '运动员管理' } },
      { path: 'adminusers', component: () => import('@/views/permission/users/adminuser.vue'), name: 'admin_users', meta: { title: '二级管理员管理' } },
      { path: 'roles', component: () => import('@/views/permission/roles/index.vue'), name: 'perm_roles', meta: { title: '角色管理' } },
      { path: 'depts', component: () => import('@/views/permission/depts/index.vue'), name: 'perm_posts', meta: { title: '部门管理' } },
      { path: 'posts', component: () => import('@/views/permission/posts/index.vue'), name: 'perm_posts', meta: { title: '岗位管理' } }
    ]
  },
  {
    path: '/system',
    component: Layout,
    meta: { title: '系统设置', icon: 'system' },
    name: 'system',
    redirect: '/system/menus',
    children: [
      { path: 'menus', component: () => import('@/views/system/menus/index.vue'), name: 'system_menus', meta: { title: '资源管理' } },
      { path: 'oss', component: () => import('@/views/system/oss/index.vue'), name: 'system_oss', meta: { title: '文件列表' } },
      { path: 'matchconfig', component: () => import('@/views/btkapp/config/index.vue'), name: 'matchconfig', meta: { title: '比赛配置' } },
      { path: 'contact', component: () => import('@/views/btkapp/contact/index.vue'), name: 'contact', meta: { title: '技术咨询配置' } }
    ]
  },
  {
    path: '/component',
    component: Layout,
    meta: { title: '组件', icon: 'component' },
    redirect: '/component/index',
    children: [
      { path: 'index', component: () => import('@/views/components-demo/index.vue'), name: 'component_index', meta: { title: '组件' } }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})

export default router
